module.exports = __webpack_public_path__ + "img/teachingCenter.eaac1bd9.png";